import {alpha} from '@material-ui/core/styles';

export const dialogScrollbar = theme => ({
  '&::-webkit-scrollbar': {
    width: 6,

    [theme.breakpoints.down('sm')]: {width: 4}
  },
  '&::-webkit-scrollbar-track': {
    // backgroundColor: 'transparent',
    borderRadius: 12,
    // opacity: 0.1,
    backgroundColor: alpha('#404C66', 0.1)
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#404C66',
    borderRadius: 12
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: alpha('#404C66', 0.8)
  }
});

export const tableScrollbar = theme => ({
  '&::-webkit-scrollbar': {
    width: 6,
    height: 4,

    [theme.breakpoints.down('sm')]: {width: 4}
  },
  '&::-webkit-scrollbar-track': {
    // backgroundColor: 'transparent',
    borderRadius: 12,
    // opacity: 0.1,
    backgroundColor: alpha('#404C66', 0.1)
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#404C66',
    borderRadius: 12
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: alpha('#404C66', 0.8)
  }
});
